import { observeElement } from '@uvocore-front/utils';
import { isMobile } from '../../../../utils';
import SamplesInfo from '../../../Sample/SamplesInfo';
import SamplesModal from '../../../Sample/SamplesModal';
import MobileSlider from './functions/MobileSlider';
import initDesktopHorizontalGlider from './functions/initDesktopHorizontalGlider';


document.addEventListener('DOMContentLoaded', () => {
  const samplesSection = document.querySelector('.SamplesSection');
  const samplesAmount = document.querySelectorAll('.Sample')?.length;
  // eslint-disable-next-line max-len
  // samplesAmount > 3 - is quick fix for two pages with only 3 samples (/accounting.html, /statistic.scss)

  if (samplesSection) {
    observeElement({
      element: '.SamplesSection',
      marginValue: 200,
      callback: () => {
        if (isMobile()) {
          // init Mobile Slider
          const samplesItems = document.querySelectorAll('[data-samples-items]');
          [].slice.call(samplesItems).forEach((item) => {
            const initMobileSlider = new MobileSlider({
              container: item,
            });

            initMobileSlider.init();
          });
        } else if (!isMobile()) {
          // init samples info tooltip
          SamplesInfo({
            samplesSelector: '[data-samples-item]',
            previewBlockSelector: '[data-sample-preview]',
            infoBlockSelector: '[data-sample-info]',
          });

          // init samples pdf modal
          SamplesModal({
            sampleBtn: '[data-sample-url]',
          });
        }
      },
    });

    if (!isMobile() && samplesAmount > 3) setTimeout(initDesktopHorizontalGlider, 2000);
  }
}, false);
